import React from 'react';
import PropTypes from 'prop-types';

import AuthenticationStructure from '../../components/AuthenticationStructure';
import AccountLinkMessage from '../../components/AccountLinkMessage';

export default class SocialLinkedAccountPage extends React.Component {
    static propTypes = {
        handleSetLinkedAccount: PropTypes.func.isRequired,
        isLoading: PropTypes.bool,
        socialLinkedAccountStatus: PropTypes.string,
        onCloseButtonClick: PropTypes.func,
    };

    componentDidMount() {
        const {
            router: {
                location: { query },
            },
        } = this.props;

        this.props.handleSetLinkedAccount(query);
    }

    render() {
        const {
            isLoading,
            socialLinkedAccountStatus,
            onCloseButtonClick,
        } = this.props;

        return (
            <AuthenticationStructure sectionClassName="eds-l-pad-vert-14 eds-bg-color--ui-100">
                <AccountLinkMessage
                    status={socialLinkedAccountStatus}
                    isLoading={isLoading}
                    onCloseButtonClick={onCloseButtonClick}
                />
            </AuthenticationStructure>
        );
    }
}
